import React from 'react'
import FileFormatIcon from '../../../../common/FileFormatIcon'
import { DocumentWithText } from '../../../../../lib/api/types/document.interfaces'
import { Tooltip } from '../../../../ui'

interface AskAiDialogItemProps {
	item: DocumentWithText
	onPreview: (
		id: string,
		versionId?: string | null,
		type?: number | null
	) => void
}

const AskAiDialogItem: React.FC<AskAiDialogItemProps> = ({
	item: { text, name, id, versionId, type },
	onPreview,
}) => {
	return (
		<div className="p-2 w-[calc(100%-32px)] h-22 bg-background-light dark:bg-background-light-dark rounded-lg flex items-start flex-col marker:p-2 text-text-main dark:text-text-main-dark font-Roboto">
			<p className="text-text-main dark:text-text-main-dark text-sm max-w-[95%] pl-1 pt-1 line-clamp-3 w-full">
				{text}
			</p>
			<div
				className="my-2 flex items-center h-10 px-2 box-border rounded-lg gap-2.5 max-w-full cursor-pointer text-text-main dark:text-text-main-dark font-Roboto dark:border-stroke-light-dark text-sm bg-white dark:bg-background-dark border border-solid border-stroke-light"
				onClick={() => {
					onPreview(id, versionId, type)
				}}
			>
				<FileFormatIcon
					fileName={name}
					isFolder={false}
					className="fill-text-secondary  min-w-5 h-5 w-5"
				/>
				<Tooltip label={name}>
					<p className="text-text-main dark:text-text-main-dark max-w-full font-medium text-sm truncate">
						{name}
					</p>
				</Tooltip>
			</div>
		</div>
	)
}

export default AskAiDialogItem
